import { SparklesIcon } from '@heroicons/react/24/outline';
export const SparkleIcon = SparklesIcon;
